import tracking from './tracking';

const endlessListingScrolling = {
    init() {
        const scroller = document.querySelector('.js-listings');
        const sentinel = document.querySelector('.js-sentinel');
        const paginationWrapper = document.querySelector('.js-pagination-wrapper');

        if (scroller && sentinel) {
            let loadMoreUrl = scroller.getAttribute('data-load-more-url');

            // Intersection-Observer überwacht
            const intersectionObserver = new IntersectionObserver((entries) => {
                // Wenn intersectionRatio 0 ist, ist der 'sentinel' außer Sicht und es muss nichts passieren
                if (entries[0].intersectionRatio <= 0) {
                    return;
                }

                if (loadMoreUrl) {
                    endlessListingScrolling.loadMore(loadMoreUrl, scroller).then((result) => {
                        if (result) {
                            window.history.pushState(null, null, result.stateUrl);

                            scroller.insertAdjacentHTML('beforeend', result.markup);

                            paginationWrapper.classList.add('sticky-pagination');

                            loadMoreUrl = result.nextAjaxUrl;
                            if (loadMoreUrl) {
                                scroller.appendChild(sentinel);
                            } else {
                                // Wenn die letzten Ergebnisse geladen werden,
                                // setzen wir die Pagination wieder unter die Listings
                                paginationWrapper.classList.remove('sticky-pagination');
                                scroller.removeChild(sentinel);
                            }

                            paginationWrapper.innerHTML = result.pagination;

                            tracking.track({l: result.listingIds});
                        } else {
                            scroller.insertAdjacentHTML('beforeend', '<li>Es ist ein Fehler aufgetreten</li>');
                            scroller.removeChild(sentinel);
                        }
                    });
                }
            });

            intersectionObserver.observe(sentinel);
        }
    },

    async loadMore(url) {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body: `currentUrl=${encodeURIComponent(window.location)}`,
            });
            return await response.json();
        } catch (err) {
            return false;
        }
    },
};

export default endlessListingScrolling;
